/** Returns a hex color string for a given HR zone key */
export function hrZoneColor(zone: string | null): string {
  const map: Record<string, string> = {
    ZONE_1: '#8E9AAF',
    ZONE_2: '#3CC8D0',
    ZONE_3: '#8BD86A',
    ZONE_4: '#FF9640',
    ZONE_5: '#FF5C9A',
  }
  return zone ? (map[zone] ?? '#B4B3C2') : '#B4B3C2'
}

/** Returns a short zone label (Z1–Z5) */
export function hrZoneName(zone: string | null): string {
  const map: Record<string, string> = {
    ZONE_1: 'Z1',
    ZONE_2: 'Z2',
    ZONE_3: 'Z3',
    ZONE_4: 'Z4',
    ZONE_5: 'Z5',
  }
  return zone ? (map[zone] ?? '—') : '—'
}

/** Format milliseconds as MM:SS or H:MM:SS */
export function formatTime(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000)
  const h = Math.floor(totalSeconds / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)
  const s = totalSeconds % 60
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
  }
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

/** Minimal classnames helper */
export function cn(
  ...classes: (string | undefined | false | null)[]
): string {
  return classes.filter(Boolean).join(' ')
}

/** Truncate a string to maxLen characters */
export function truncate(str: string, maxLen: number): string {
  if (str.length <= maxLen) return str
  return str.slice(0, maxLen - 1) + '…'
}

/** Format a Date or ISO string as HH:MM:SS */
export function formatClock(date: Date): string {
  const h = String(date.getHours()).padStart(2, '0')
  const m = String(date.getMinutes()).padStart(2, '0')
  const s = String(date.getSeconds()).padStart(2, '0')
  return `${h}:${m}:${s}`
}

/** Format a Date or ISO string as "Mon 12 Apr, 9:00 AM" */
export function formatClassTime(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleString('en-US', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

/** Get athlete initials from full name */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

/** Rank medal colors for top-3 podium */
export function rankMedalColor(rank: number): string {
  if (rank === 1) return '#f59e0b' // gold
  if (rank === 2) return '#B4B3C2' // silver
  if (rank === 3) return '#b45309' // bronze
  return '#374151'
}
